import { customElement } from 'lit/decorators.js';
import {
  css, CSSResult, html, LitElement, TemplateResult, unsafeCSS,
} from 'lit';
import styles from './action-menu-item.scss';
import typographyStyles from '../../../styles/responsive-nui-typography.scss';

@customElement('ents-action-menu-item')
export class ActionMenu extends LitElement {

  static get styles(): CSSResult[] {
    return [css`${unsafeCSS(styles)}`, css`${unsafeCSS(typographyStyles)}`];
  }

  private handleClick() {
    this.dispatchEvent(new CustomEvent('ents-action-menu-item-clicked', { composed: true, bubbles: true }));
  }

  protected render(): TemplateResult {
    return html`
      <button class="ents-action-menu-item" @click="${this.handleClick}" data-test-ents-action-menu-item>
            <div class="ents-action-menu-item__content">
                <slot></slot>
            </div>
            <slot name="arrow"></slot>
      </button>
    `;
  }
}
